import { css } from '@emotion/css';
import colors from '@/theme/colors';

const styles = {
  button: css`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    cursor: pointer;
    padding: 0px !important;
  `,
  menuItem: css`
    padding: 0px !important;
    display: flex;
    align-items: center;
    gap: 8px;
   
    width: 100%;
    cursor: pointer;

    &:hover {
      background-color: #f7f7f7 !important;
    }

    &.Mui-focusVisible:not(.Mui-selected),
    &:focus-visible:not(.Mui-selected) {
      background-color: transparent !important;
      outline: 2px solid ${colors.focusOutlineColor};
      outline-offset: -2px;
    }

    &.Mui-selected:hover {
      background-color: #f7f7f7 !important;
    }

    &.Mui-selected.Mui-focusVisible,
    &.Mui-selected:focus-visible {
      background-color: ${colors.platinum} !important;
      outline: 2px solid ${colors.focusOutlineColor};
      outline-offset: -2px;
    }
  `,
  optionMenu: css`
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
    padding: 8px 16px 8px;
  `,
  activeOption: css`
    @media (max-width: 480px) {
      white-space: nowrap;
      max-width: 198px;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  `,
  popper: css`
    min-width: 262px;
    margin-top: 6px !important;
  `,
  buttonWrapper: css`
    display: flex;
    flex-direction: row;
    gap: 8px;
  `,
  userInfo: css`
    gap: 8px;
    cursor: pointer;
    text-align: left;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  `,
  parentOption: css`
    display: flex;
    flex-direction: column;
    gap: 2px;
    padding: 0px 16px 8px 13px;
    width: 100%;
    background-color: ${colors.platinum};
    border-left: 3px solid ${colors.jungle};
    border-bottom: 1px solid ${colors.platinum};
  `,
  otherAccountLabel: css`
    padding: 16px 16px 0px;
  `,
};

export default styles;
